import { instances } from "./instances"
import {
  setToken,
  deleteToken,
  deleteUser,
  setUser,
  setUserId,
  deleteUserId,
  setFirstLogIn,
  deleteFirstLogIn,
  deteleExpireTokenDate,
  setExpireTokenDate,
  setProfileThumbnail,
  deleteProfileThumbnail,
  setUbicacion,
  deleteUbicacion,
  setNavbar,
  deleteNavbar,
  setFastAccess,
  deleteFastAccess,
  setWidgets,
  deleteWidgets,
  setPuesto,
  deletePuesto,
} from "./helpers/localstorage"
import { loginEndpoints } from "./sources"
import { checkTokenExpire } from "Helpers"

const headers = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
}

function get(endpoint) {
  checkTokenExpire()
  return instances.instanceCommon
    .get(endpoint, headers)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

//I don't know why i cant use the word delete haha
function del(endpoint) {
  checkTokenExpire()
  return instances.instanceCommon
    .delete(endpoint, headers)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function post(endpoint, body) {
  checkTokenExpire()
  return instances.instanceCommon
    .post(endpoint, body, headers)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function postWithoutAuth(endpoint, body) {
  return instances.instanceCommon
    .post(endpoint, body, headers)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function put(endpoint, body) {
  checkTokenExpire()
  return instances.instanceCommon
    .put(endpoint, body, headers)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function authLogin(username, password) {
  const postOptions = {
    method: "POST",
    data: {
      username,
      password,
    },
    headers: {
      "Content-Type": "application/json",
    },
  }
  return instances
    .instanceCommon(loginEndpoints.ACCOUNT_LOGIN, postOptions)
    .then((res) => {
      if (res.data.firstLogIn) {
        setToken(res.data.access_token)
        return Promise.resolve(res.data)
      } else {
        if (res.data && res.data.access_token) {
          setUserId(res.data.user_id)
          setToken(res.data.access_token)
          setUser(JSON.stringify(res.data.user))
          setFirstLogIn(res.data.firstLogIn)
          setExpireTokenDate(res.data.expireAt)
          setProfileThumbnail(res.data.profile)
          setUbicacion(res.data.ubicacion)
          setNavbar(JSON.stringify(res.data.navbar))
          setFastAccess(JSON.stringify(res.data.fastAccess))
          setWidgets(JSON.stringify(res.data.widgets))
          setPuesto(JSON.stringify(res.data.puesto))
          return Promise.resolve(res.data)
        } else {
          return Promise.reject("Error: response result not found")
        }
      }
    })
    .catch((error) => Promise.reject(error))
}

function refreshToken(id) {
  const postOptions = {
    method: "POST",
    data: {
      id,
    },
    headers: {
      "Content-Type": "application/json",
    },
  }
  return instances
    .instanceCommon(loginEndpoints.REFRESH_TOKEN, postOptions)
    .then((res) => {
      if (res.data && res.data.access_token) {
        setToken(res.data.access_token)
        setExpireTokenDate(res.data.expireAt)
        return res
      } else {
        return Promise.reject("Error: response result not found")
      }
    })
    .then((res) => {
      return Promise.resolve(res.data.user)
    })
    .catch((error) => Promise.reject(error))
}

function uploadSingleFile(endpoint, file) {
  checkTokenExpire()
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
  let formData = new FormData()
  formData.append("file", file)
  return instances.instanceCommon
    .post(endpoint, formData, options)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function uploadFiles(endpoint, files, initialName) {
  checkTokenExpire()
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
  let formData = new FormData()
  if (initialName) {
    let sum = initialName
    files.forEach((file) => {
      let n = file.name.lastIndexOf(".")
      let extension = file.name.substring(n + 1)
      let filename = sum + "." + extension
      formData.append("files", file, filename)
      sum++
    })
  } else {
    files.forEach((file) => {
      formData.append("files", file)
    })
  }
  return instances.instanceCommon
    .post(endpoint, formData, options)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}
function getPDF(endpoint, body) {
  checkTokenExpire()
  const postOptions = {
    method: "POST",
    responseType: "blob",
    data: body,
  }
  return instances
    .instanceCommon(endpoint, postOptions)
    .then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        return res
      } else {
        return Promise.reject(res)
      }
    })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}
function logout() {
  deleteToken()
  deleteUser()
  deleteFirstLogIn()
  deteleExpireTokenDate()
  deleteUserId()
  deleteProfileThumbnail()
  deleteUbicacion()
  deleteNavbar()
  deleteFastAccess()
  deleteWidgets()
  deletePuesto()
}

export const axiosService = {
  get,
  post,
  postWithoutAuth,
  put,
  del,
  authLogin,
  refreshToken,
  logout,
  uploadSingleFile,
  uploadFiles,
  getPDF,
}
